import styles from './SmallLoader.module.scss';

export const SmallLoader = () => {
  return <span className={styles.loader} />;
};
